import { RecentOrFavoriteOrder, RecentOrFavoriteEntree } from '@/models';
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { GETTERS as CUSTOMER_GETTERS } from '@/store/customer';
import { GETTERS as RESTAURANT_GETTERS } from '@/store/restaurant';
import moment from 'moment';
import { SwiperOptions } from 'swiper';
import { swiper, swiperSlide, SwiperComponent } from 'vue-awesome-swiper';
export interface RecentMeal {
  item: RecentOrFavoriteEntree;
  orderDate: string;
}
@Component({
  name: 'CmgNutritionCalculatorRecents',
  components: {
    swiper,
    swiperSlide,
  },
})
export default class CmgNutritionCalculatorRecents extends Vue {
  isLoadingRecents = false;

  swiperOptions: SwiperOptions = {
    slidesPerView: 'auto',
    centeredSlides: true,
    spaceBetween: 15,
  };

  recentMeals: RecentMeal[] = [];

  get countryCode(): string {
    return this.$appStore.state.ui.countryProfile.countryCode;
  }

  get recentOrders(): RecentOrFavoriteOrder[] {
    return this.$appStore.getters[CUSTOMER_GETTERS.RECENT_ORDERS];
  }

  get selectedRestaurantId(): number {
    return this.$appStore.getters[RESTAURANT_GETTERS.GET_SELECTED_RESTAURANT_ID];
  }

  @Watch('recentOrders', { immediate: true, deep: true })
  onRecentOrdersChanged(newRecentOrders: RecentOrFavoriteOrder[]) {
    if (newRecentOrders.length != 0) {
      this.recentMeals = this.getRecentMeals();
    }
  }

  @Watch('selectedRestaurantId', { immediate: true, deep: true })
  async onRestaurantChanged(selectedRestaurantId: number) {
    await this.$services.monoMenu.awaitCacheItemsAndBuildMenu();
    this.refreshRecents();
  }

  // Get max of 3 recent meals
  getRecentMeals(): RecentMeal[] {
    let recentMeals = [] as RecentMeal[];
    let availableRecentOrders = this.recentOrders?.filter(x => x.order.isOrderAvailable);

    availableRecentOrders.forEach(recentOrder => {
      if (recentMeals.length >= 3) {
        return recentMeals.slice(0, 3);
      }

      let formattedDate = moment(recentOrder.orderDateTime).format(this.countryCode === 'GB' ?  'DD/MM/YYYY' : 'MM/DD/YYYY');

      recentOrder.order.meals?.forEach(meal => {
        meal.entrees?.forEach(entree => {
          if (this.isEntreeAvailable(entree)) {
            recentMeals.push({ item: entree, orderDate: formattedDate });
          }
        });
      });
    });

    return recentMeals.slice(0, 3);
  }

  get hasThreeMeals(): boolean {
    return this.recentMeals?.length == 3;
  }

  get hasOneMeal(): boolean {
    return this.recentMeals?.length == 1;
  }

  async mounted() {
    await this.refreshRecents();
  }

  async refreshRecents() {
    this.$services.logger.debug('Refreshing recents');
    this.isLoadingRecents = true;
    try {
      await this.$services.recentAndFavoriteOrders.refreshRecentOrders();
    } catch (e: any) {
      this.$services.logger.error('Something went wrong while refreshing recent orders', undefined, e);
    } finally {
      this.isLoadingRecents = false;
    }
  }

  isEntreeAvailable(entree: RecentOrFavoriteEntree): boolean {
    if (!this.$services.monoMenu.isItemInMenu(entree.menuItemId)) {
      return false;
    }

    return true;
  }

  goToFirstSwiperSlide(): void {
    const recentFavSwiper = this.$refs.recentsNutritionSwiper as SwiperComponent;

    if (recentFavSwiper.swiper) {
      recentFavSwiper.swiper.slideTo(0);
    }
  }
}
